import React, { useMemo } from 'react';
import { useLoggedInUser, useFeatureFlags } from '@tcc/shared-data-lib';
import { importFromS3 } from '../../utils/importFromS3';
import { Operation } from '../../hooks/useOperations/types';
import { useUserLoggedInConfigs, useFeatureFlagsConfigs } from '../../utils/sharedData';
import { useImpersonatedOperation } from '../../hooks/useImpersonatedOperation';


type PluginProps = {
  operations: Operation[];
};

const S3Plugin = React.lazy(() => importFromS3('dashboard'));
const MFPlugin = React.lazy(() => import('dashboard/Dashboard'));

export const DashboardPluginContainer = ({ operations }: PluginProps) => {
  const { user } = useLoggedInUser(useUserLoggedInConfigs);
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs(user));
  const useModuleFederation = featureFlags?.['web.dashboard.module-federation'];

  const DashboardPlugin = useModuleFederation ? MFPlugin : S3Plugin;

  const { operation: impersonatedOperation } = useImpersonatedOperation();
  const firstRealOperation = operations[1];
  const selectedOperations = useMemo(() => {
    if (impersonatedOperation) return [impersonatedOperation];
    // operations[0] is the synthetic "All Operations" sentinel; index 1 is the
    // user's first real operation. It is undefined when the user has none, so
    // fall back to an empty array instead of passing [undefined] to the plugin.
    return firstRealOperation ? [firstRealOperation] : [];
  }, [impersonatedOperation, firstRealOperation]);

  return <DashboardPlugin operations={selectedOperations} />;
};
